<template>
  <div>
    <div>
      <van-nav-bar :title="my.name" right-text="修改密码" @click-right="onClickRight" fixed></van-nav-bar>
    </div>
    <div style="margin-bottom: 45px;margin-top: 45px;">
      <img class="user-poster" src="../../assets/logo.png">
      <van-row class="user-links">
        <van-col span="4">
          <van-icon name="add-o" :info="counts.new?counts.new.num!==0?counts.new.num:'':''"/>
          新增
        </van-col>
        <van-col span="4">
          <van-icon name="sign" :info="counts.remindUnfinished?counts.remindUnfinished.num!==0?counts.remindUnfinished.num:'':''"/>
          小铃铛
        </van-col>
        <van-col span="4">
          <van-icon name="pending-payment" :info="counts.waitMeet?counts.waitMeet.num!==0?counts.waitMeet.num:'':''"/>
          待约访
        </van-col>
        <van-col span="4">
          <van-icon name="contact" :info="counts.meet?counts.meet.num!==0?counts.meet.num:'':''"/>
          约访中
        </van-col>
        <van-col span="4">
          <van-icon name="pending-deliver" :info="counts.come?counts.come.num!==0?counts.come.num:'':''"/>
          总来访
        </van-col>
        <van-col span="4">
          <van-icon name="exchange" :info="counts.success?counts.success.num!==0?counts.success.num:'':''"/>
          总成交
        </van-col>
      </van-row>

      <van-cell-group>
        <van-cell v-if="counts.customerPool" icon="records" title="待分配总数">
          <van-tag v-if="counts" style="width: 50px;text-align: center;" type="danger">{{ counts.customerPool?counts.customerPool.num:'' }}</van-tag>
        </van-cell>
        <van-cell v-if="counts.waitAllot" icon="records" title="待分配总数">
          <van-tag v-if="counts" style="width: 50px;text-align: center;" type="danger">{{ counts.waitAllot?counts.waitAllot.num:'' }}</van-tag>
        </van-cell>
        <van-cell icon="records" title="今日已完成约访客户总数">
          <van-tag v-if="counts.waitMeetEnd" style="width: 50px;text-align: center;" type="danger">{{ counts.waitMeetEnd?counts.waitMeetEnd.num:'' }}</van-tag>
        </van-cell>
        <van-cell icon="records" title="今日预计来访客户">
          <van-tag v-if="counts.comeExpect" style="width: 50px;text-align: center;" type="danger">{{ counts.comeExpect?counts.comeExpect.num:'' }}</van-tag>
        </van-cell>
        <van-cell icon="exchange" title="今日实际来访">
          <van-tag v-if="counts.comeActual" style="width: 50px;text-align: center;" type="danger">{{ counts.comeActual?counts.comeActual.num:'' }}</van-tag>
        </van-cell>
        <van-cell icon="gold-coin" title="今日成交套数">
          <van-tag v-if="counts.successToday" style="width: 50px;text-align: center;" type="danger">{{ counts.successToday?counts.successToday.num:'' }}</van-tag>
        </van-cell>
        <van-cell icon="gift" title="本周来访任务已完成几个">
          <van-tag v-if="counts.comeTaskWeek" style="width: 50px;text-align: center;" type="danger">{{ counts.comeTaskWeek?counts.comeTaskWeek.num:'' }}</van-tag>
        </van-cell>
        <van-cell icon="gift" title="本月成交已完成几个">
          <van-tag v-if="counts.successTaskMonth" style="width: 50px;text-align: center;" type="danger">{{ counts.successTaskMonth?counts.successTaskMonth.num:'' }}</van-tag>
        </van-cell>
      </van-cell-group>

      <van-button  v-if="showButton"  size="large" type="danger" class="pop_button" @click="onLogout">退出</van-button>
    </div>

    <!--扩展界面开始-->
    <div>
      <van-popup v-model="show" position="right" style="width:100%;height: 100%;overflow: auto">
        <div>
          <van-nav-bar
            title="修改密码"
            left-text="返回"
            left-arrow
            @click-left="onClickUpdateLeft"
            fixed>
          </van-nav-bar>

          <div style="margin-top: 55px;" >
            <van-field
              v-model="password"
              type="password"
              label="密码"
              placeholder="请输入密码"
              :error-message="password_error"
              icon="clear"
              @click-icon="password = ''"
            />
            <van-field
              v-model="password_confirmation"
              type="password"
              label="确认密码"
              placeholder="请再次输入密码"
              :error-message="password_confirmation_error"
              icon="clear"
              @click-icon="password_confirmation = ''"
            />

            <van-button size="large" type="danger" class="pop_button" @click="onUpdateConfirm">确定</van-button>
          </div>
        </div>

      </van-popup>
    </div>
    <!--扩展界面结束-->

  </div>
</template>


<script>
  export default {
    data() {
      return {
        activeName: "",
        counts:[],
        my:[],
        password:"",
        password_confirmation:"",
        password_error:"",
        password_confirmation_error:"",
        show: false,
        showButton:false
      };
    },
    methods: {
      onLogout() {
        this.$dialog.confirm({
          title: '提示',
          message: '是否退出系统'
        }).then(() => {
          window.localStorage.token  = "";
          this.$router.push('/');
        }).catch(() => {
          // on cancel
        });
      },
      onClickRight() {
        this.show = true
      },
      onClickUpdateLeft() {
        this.show = false
      },
      onUpdateConfirm() {
        console.log(this.password.length)
        if(this.password.length < 6){
          this.password_error = "密码不能小于6位"
        } else if(this.password_confirmation.length < 6){
          this.password_confirmation_error = "密码不能小于6位"
        } else if(this.password !== this.password_confirmation){
          this.password_confirmation_error = "两次密码不一致"
        } else {
          //获取个人统计
          this.$api.post('/api/employee/update', {
              password:this.password,
              password_confirmation:this.password_confirmation,
            },then => {
              this.$toast("修改成功")
              this.show = false
            },error => {
              this.password_error = error.data.message
            }
          )
        }
      },
    },
    created: function () {
      window.scroll(0, 0)
      //获取个人统计
      this.$api.post('/api/employee/counts', null,
        r => {
          this.counts = r.counts
          this.showButton = true
        }
      )

      //获取个人信息
      this.$api.post('/api/employee', null,
        r => {
          this.my = r
          this.showButton = true
        }
      )
    }
  };
</script>

<style scoped>
  .user-poster {
    width: 100%;
    height: 30%;
    display: block;
  }
  .user-group {
    margin-bottom: .3rem;
  }
  .user-links {
    padding: 15px 0;
    font-size: 12px;
    text-align: center;
    background-color: #fff;
  }
  .van-icon {
    display: block;
    font-size: 24px;
  }
  .van-collapse-item__content__xwzhu {
    font-size: 13px;
    line-height: 1.5;
    color: #666;
  }
  .pop_button{
    width: 80%;
    margin-left: 10%;
    margin-top: 20px;
    margin-bottom: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/employee/index.vue